import { Context, CustomQuery } from '@vue-storefront/core';
import { ApiResult } from '../../types';
// 文章分类
export default async function ArtcleCatList(context: Context, params: CustomQuery): Promise<ApiResult> {
  const url = new URL('/mall/article/cat/list', context.config.api.url);
  const { data: res } = await context.client.post(url.href, params);
  return res;
}
